import { apiCallTypeCreator } from 'Redux/utilities';

export default class types {
	static CONTRACT_GENERATOR = 'CONTRACT_GENERATOR';

	static EXTENSIONS = `${types.CONTRACT_GENERATOR}/EXTENSIONS`;

	static PRODUCTS = `${types.CONTRACT_GENERATOR}/PRODUCTS`;

	static ENABLE_STEP_2_FORM = `${types.CONTRACT_GENERATOR}/ENABLE_STEP_2_FORM`;

	static FORMS = `${types.CONTRACT_GENERATOR}/FORMS`;

	static FORM_FIELDS = `${types.CONTRACT_GENERATOR}/FORM_FIELDS`;

	static CONSTANTS = `${types.CONTRACT_GENERATOR}/CONSTANTS`;

	static SESSION = `${types.CONTRACT_GENERATOR}/SESSION`;

	static USER = `${types.CONTRACT_GENERATOR}/USER`;

	static FETCH = 'FETCH';

	static SUBMIT = 'SUBMIT';

	static ACTIVATE_STEP_2 = 'ACTIVATE_STEP_2';

	static SAVE_SESSION = 'SAVE_SESSION';

	static LOGIN = 'LOGIN';

	static LOG_DATA = 'LOG_DATA';

	static GET_CALL = 'GET_CALL';

	static POST_CALL = 'POST_CALL';

	static SET_ACTIVE_STEP = `${types.CONTRACT_GENERATOR}/SET_ACTIVE_STEP`;

	static SET_WINDOW_SIZE = `${types.CONTRACT_GENERATOR}/SET_WINDOW_SIZE`;

	static SET_FIELD_INFO = `${types.CONTRACT_GENERATOR}/SET_FIELD_INFO`;

	static SET_DATA_TO_SUBMIT = `${types.CONTRACT_GENERATOR}/SET_DATA_TO_SUBMIT`;

	static SET_DISCOUNT_FIELD_INFO = `${types.CONTRACT_GENERATOR}/SET_DISCOUNT_FIELD_INFO`;

	static SET_DISCOUNT_DATA_TO_SUBMIT = `${types.CONTRACT_GENERATOR}/SET_DISCOUNT_DATA_TO_SUBMIT`;

	static SET_ERROR_MESSAGES_VISIBLE = `${types.CONTRACT_GENERATOR}/SET_ERROR_MESSAGES_VISIBLE`;

	static RESET_STORE = `${types.CONTRACT_GENERATOR}/RESET_STORE`;

	static DELETE_KEY = `${types.CONTRACT_GENERATOR}/DELETE_KEY`;

	static GET_CALLS = {
		FETCH_EXTENSIONS: apiCallTypeCreator(`${types.EXTENSIONS}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_PRODUCTS: apiCallTypeCreator(`${types.PRODUCTS}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_ENABLE_STEP_2_FORM: apiCallTypeCreator(`${types.ENABLE_STEP_2_FORM}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_FORMS: apiCallTypeCreator(`${types.FORMS}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_FORM_FIELDS: apiCallTypeCreator(`${types.FORM_FIELDS}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_CONSTANTS: apiCallTypeCreator(`${types.CONSTANTS}/${types.GET_CALL}/${types.FETCH}`),
		FETCH_SESSION: apiCallTypeCreator(`${types.SESSION}/${types.GET_CALL}/${types.FETCH}`),
		CHECK_USER_SESSION: apiCallTypeCreator(`${types.USER}/${types.GET_CALL}/${types.FETCH}`)
	};

	static POST_CALLS = {
		SUBMIT: apiCallTypeCreator(`${types.CONTRACT_GENERATOR}/${types.POST_CALL}/${types.SUBMIT}`),
		ACTIVATE_STEP_2: apiCallTypeCreator(`${types.CONTRACT_GENERATOR}/${types.POST_CALL}/${types.ACTIVATE_STEP_2}`),
		SAVE_SESSION: apiCallTypeCreator(`${types.CONTRACT_GENERATOR}/${types.POST_CALL}/${types.SAVE_SESSION}`),
		LOGIN: apiCallTypeCreator(`${types.CONTRACT_GENERATOR}/${types.POST_CALL}/${types.LOGIN}`),
		LOG_DATA: apiCallTypeCreator(`${types.CONTRACT_GENERATOR}/${types.POST_CALL}/${types.LOG_DATA}`)
	};
}
